{
  "title": "Paramètres",
  "description": "Gérez votre compte, votre sécurité et vos préférences.",
  "sectionsHeading": "Paramètres",
  "appearanceHeading": "Apparence",
  "appearanceDescription": "Choisissez l'apparence de l'application. Votre thème est enregistré sur cet appareil.",
  "rows": {
    "profile": {
      "title": "Profil",
      "description": "Mettez à jour votre nom, votre e-mail et vos informations personnelles."
    },
    "security": {
      "title": "Sécurité",
      "description": "Gérez votre mot de passe, l'authentification à deux facteurs et les sessions."
    },
    "notifications": {
      "title": "Notifications",
      "description": "Choisissez comment et quand nous vous contactons."
    },
    "privacy": {
      "title": "Confidentialité",
      "description": "Gérez le consentement, l'export des données et la suppression du compte."
    },
    "billing": {
      "title": "Facturation",
      "description": "Consultez votre offre, vos factures et vos informations de paiement."
    }
  }
}
